module.exports = __webpack_public_path__ + "static/media/rooms.png";